<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <m-form
            :title="title"
            :showList="false"
            :listRoute="{name:'NoContentProductList'}"
            :show-list-btn="false"
            :items.sync="item"
            :show-navigation-btns="false"
            :canDelete="false"
            :canSubmit="true"
            :can-edit="true"
            :isEditing.sync="isEditing"
            :show-submit-and-clear-btn="false"
            :show-actions="true"
            @submit="submit"
            @delete="deleteItem"
            @clearForm="clearForm()"
            ref="ContentDevelopmentForm"

        >
          <template>
            <v-row v-if="item.id">
              <v-col cols="12">
                <v-avatar v-if="!item.picture" size="100" class="rounded-lg mr-4" color="#FFACC5">
                  <v-img
                      @click="change_picture_dialog = true"
                      style="cursor: pointer"
                      contain
                      max-height="90"
                      max-width="90"
                      src="/img/icons/product.svg"
                  />
                </v-avatar>
                <v-avatar class="mr-2" v-if="item.picture" size="100" style="cursor: pointer"
                          @click="change_picture_dialog = true">
                  <v-img class="rounded-lg" :src="img_source(item.picture)" />
                </v-avatar>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-textarea class="rounded-lg" label="* نام  " v-model="item.name" background-color="white"
                              :disabled="!isEditing"/>
              </v-col>
              <v-col cols="12">
                <v-textarea class="rounded-lg" label="* توضیخات مختصر" v-model="item.summary_explanation" background-color="white"
                              :disabled="!isEditing"/>
              </v-col>
              <v-col cols="12">
                <v-textarea class="rounded-lg" label="* توضیخات" v-model="item.explanation" background-color="white"
                              :disabled="!isEditing"/>
              </v-col>
              <v-col cols="12">
                <v-textarea class="rounded-lg" label="* نحوه استفاده" v-model="item.how_to_use" background-color="white"
                              :disabled="!isEditing"/>
              </v-col>
              <v-col cols="12" md="12">
                <category-select
                    add-new="true"
                    class="rounded-lg"
                    label="دسته بندی"
                    v-model="item.category"
                    :disabled="!isEditing"
                ></category-select>
              </v-col>

            </v-row>
          </template>
        </m-form>
        <v-row justify="center">
          <v-dialog
              v-model="change_picture_dialog"
              class="rounded-lg"
              persistent
              @click:outside="change_picture_dialog=false"
              max-width="400"
          >
            <v-card class="rounded-lg pa-2">
              <v-card-title class="primary--text text-h5">
                تغییر تصویر محصول
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <m-file-input
                        label="انتخاب تصویر"
                        v-model="picture"
                        :delete-attachment.sync="delete_picture"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    text
                    @click="change_picture_dialog = false"
                >
                  بستن
                </v-btn>
                <v-btn
                    color="success"
                    text
                    @click="updatePicture(item)"
                >
                  تغییر تصویر محصول
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>

      </v-col>
      <v-col cols="12" md="6">
        <no-content-product-list ref="datatable" :is-summary="true"></no-content-product-list>
      </v-col>
    </v-row>

  </div>

</template>

<script>

import {MFormMixin} from "@/components/m-form";
import FormsMixin from "@/mixin/forms";
import {PathLevels, VisitorLevels} from "@/variables";
import MDatatable from "@/components/m-datatable";
import formsMixin from "@/mixin/forms";
import money from "@/components/mcomponents/cleave/Money";


import TransactionForm from "@/views/panel/transaction/Form";
import {toString} from "lodash";
import NoContentProductList from "@/views/product/product/NoContentProducts";
import CategorySelect from "@/components/selects/CategorySelect";


export default {
  name: "ProductContentDevelopment",
  mixins: [MFormMixin, formsMixin, FormsMixin],
  components: {
    CategorySelect,
    NoContentProductList, MDatatable, TransactionForm, money
  },
  props: {
    id: {},
  },
  data() {
    return {
      export_filters: [],
      baseUrl: "product/contentDevelopment",
      permissionBasename: "product",
      appendSlash: true,
      hasList: false,
      hasIdProp: true,
      dont_loop: true,
      change_picture_dialog: false,
      hasLock: false,
      isDefinable: false,
      myClass: '',
      id: this.$route.params.id,
      PathLevels,
      VisitorLevels,
      first: false,
      performClearForm: true,
      is_insurance: {},
      selected: false,
      cleared: false,
      picture: null,
      delete_picture: null,
      rules: {
        required: value => !!value || 'Required.',
        bool_required: value => value != null || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
      },

    };
  },
  updated() {
    if (!this.first && this.$route.params.id) {
      this.first = true
      this.isEditing = false
    }
  },

  computed: {
    title() {
      return this.setDocumentTitle('تکمیل محتوا محصول');
    },
  },
  mounted() {
  },

  methods: {
    getUpdatePictureSerialized(selectItem) {
      let item = {
        id: selectItem.id,
        picture: this.picture,
        delete_picture: this.delete_picture,
      };

      if (typeof item["picture"] == typeof "") {
        delete item["picture"];
      }

      return this.jsonToFormData(item);
    },

    updatePicture(selectItem) {
      this.request({
        url: this.endpoint(`product/productPictureUpdate/${selectItem.id}`),
        method: "put",
        data: this.getUpdatePictureSerialized(selectItem),
        success: (data) => {
          this.successNotify();
          this.isEditing = false;
          this.change_picture_dialog = false
          this.clearForm()
        },
      });
    },

  }
}

</script>

<style scoped lang="scss"></style>

